module.exports = __webpack_public_path__ + "static/media/crane5.3e644b82.png";